<div class="step-container">
    <div class="step-header">Personalize your profile, {{ firstName }}</div>
    <div class="step-subtext">We'll use this to tailor InsightHub to your needs</div>
    <div class="step-content">
        <div class="form-content">
            <div class="form-row">
                <div class="form-input">
                    <input 
                        type="text" 
                        placeholder="Company Name" 
                        [formControl]="companyNameControl"
                        [class.error]="companyNameControl.invalid && companyNameControl.touched"
                        (keydown.enter)="onNext()">
                    <div class="error-message" *ngIf="companyNameControl.invalid && companyNameControl.touched">
                        Company Name is required
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-select-wrapper">
                    <app-select-menu
                        class="trial-step-three-select"
                        [selectMode]="SelectMode.SINGLE"
                        [control]="jobTitleControl"
                        [items]="jobTitleItems"
                        [placeholder]="'Job Title'"
                        [searchable]="true"
                        [searchPlaceholder]="'Search job title...'"
                        [showSelectedIcon]="true"
                        [width]="'100%'"
                        [hasError]="jobTitleControl.invalid && jobTitleControl.touched">
                    </app-select-menu>
                    <div class="error-message" *ngIf="jobTitleControl.invalid && jobTitleControl.touched">
                        Job Title is required
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="get-started-button" (click)="onNext()" [disabled]="isLoading">
        @if(isLoading) {
            Loading...
        } @else {
            <span>Get Started</span>
            <img [src]="'svg/chevron-right.svg' | assetVersion" alt="Get Started" width="12" height="12">
        }
    </button>
</div>
